module.exports = __webpack_public_path__ + "static/media/bz.8bcd0c3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/bz.png
// module id = 1811
// module chunks = 0